// extracted by mini-css-extract-plugin
export default {"OTTLogoWithText":"JwbP-","logoImage":"Nj2k5","skeleton-progress":"mdXAE"};